export default __webpack_public_path__ + "static/media/logo.36602221.svg";